import { associativeCmsMap } from 'app/modules/cms/tools/mapper';
import React from 'react';
import { associativeStepMap } from '../../ui/tools/mappers';
import { returnComponent } from '../../ui/tools/methods';

export const initialStepActions = {
  actionBeforePreviousStep: undefined,
  actionBeforeNextStep: undefined,
  actionNextStep: undefined,
  showPreviousButton: false,
  previousButtonLabel: '',
  showNextButton: false,
  nextButtonLabel: '',
  disableButtons: false,
  disablePreviousButton: false,
  disableNextButton: false,
  form: '',
  fullSize: false,
  stepsLoaded: false
};

export const initialState = {
  errorJourney: null as string,
  previousStep: null as number,
  subscriptionProcessing : false,
  isLoaded: false,
  stepsLoaded: false,
  currentStep: 1,
  journeyStepsList: ['confirmOfferStep', 'confirmationStep', 'confirmationBarcodeStep', 'cancellationStep', 'tooLateStep', 'tooEarlyStep'],
  journeySteps: {
    confirmOfferStep: {
      component: returnComponent(associativeStepMap.get('confirmOfferStep')),
      cmsType: associativeCmsMap.get('confirmOfferStep'),
      showStepActions: true
    },
    confirmationStep: {
      component: returnComponent(associativeStepMap.get('confirmationStep')),
      cmsType: associativeCmsMap.get('confirmationStep'),
      showStepActions: false,
      endStepType: 'confirmation'
    },
    confirmationBarcodeStep: {
      component: returnComponent(associativeStepMap.get('confirmationBarcodeStep')),
      cmsType: associativeCmsMap.get('confirmationBarcodeStep'),
      showStepActions: false,
      endStepType: 'confirmation'
    },
    cancellationStep: {
      component: returnComponent(associativeStepMap.get('cancellationStep')),
      cmsType: associativeCmsMap.get('cancellationStep'),
      showStepActions: false,
      endStepType: 'cancellation'
    },
    tooLateStep: {
      component: returnComponent(associativeStepMap.get('tooLateStep')),
      cmsType: associativeCmsMap.get('tooLateStep'),
      showStepActions: true
    },
    tooEarlyStep: {
      component: returnComponent(associativeStepMap.get('tooEarlyStep')),
      cmsType: associativeCmsMap.get('tooEarlyStep'),
      showStepActions: true
    }
  } as { [id: string]: any },
  nbSteps: 0,
  title: null as string,
  subTitles: null as string[],
  ...initialStepActions
};

export type StepState = Readonly<typeof initialState>;

export interface StepActions {
  actionBeforePreviousStep?: () => Promise<boolean> | (() => Promise<(dispatch: any) => Promise<boolean>>);
  actionBeforeNextStep?: () => Promise<boolean> | (() => Promise<(dispatch: any) => Promise<boolean>>);
  actionNextStep?: any;
  showPreviousButton?: boolean;
  previousButtonLabel?: string;
  showNextButton?: boolean;
  nextButtonLabel?: string;
  disableButtons?: boolean;
  disablePreviousButton?: boolean;
  disableNextButton?: boolean;
  form?: string;
  fullSize?: boolean;
  nbSteps?: number;
}
